import React, { useState } from 'react';
import 'src/style/tenant.css';
import { useDispatch, useSelector } from 'react-redux';
import { createStage } from 'src/redux/Actions/Organisation';
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from 'src/components/Breadcrumb';
import { useSetBreadcrumbData } from 'src/utils/SetBreadcrumbData';
import usePageTitle from 'src/utils/SetPageTitle';
import { useLocation } from 'react-router-dom';

export default function CreateStageForm() {
  usePageTitle('Cloud VT • Create');
  const location = useLocation();
  const dispatch = useDispatch();
  const authReducer = useSelector((state) => state.AuthReducer);
  const organisationId = authReducer.userData.organisations?.id;

  const [formData, setFormData] = useState({
    name: '',
    stage_order: '',
    description: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      tenant_organisation_id: organisationId,
    };

    dispatch(createStage(payload)).then(() => {
      setFormData({ name: '', stage_order: '', description: '' });
    });
  };

  useSetBreadcrumbData(location.pathname, 'Create');

  return (
    <div className="page-layout div-space-between div-flex-column rg-20">
      <div className="div-flex-column">
        <div className="div-space-between div-flex-column border-bottom">
          <div className="div-flex-row cg-5 left-padding padding-bottom-8">
            <Breadcrumb />
          </div>
          <div className="text-xxl text-semi-bold left-padding">
            Create Stages
          </div>
        </div>
        <div>
          <div className="setting-sidebar-container">
            <span className="text-xxxl text-bold">Stage Form</span>
          </div>
          <div className="form-body-section">
            <Row className="m-0 rg-20">
              <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                <div className="div-flex-column">
                  <span className="text-md text-bold">Name:</span>
                  <input
                    name="name"
                    className="form-input-section"
                    type="text"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                <div className="div-flex-column">
                  <span className="text-md text-bold">Stage Order:</span>
                  <input
                    name="stage_order"
                    className="form-input-section"
                    type="text"
                    value={formData.stage_order}
                    onChange={handleChange}
                  />
                </div>
              </Col>

              <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className="div-flex-column">
                  <span className="text-md text-bold">Description:</span>
                  <textarea
                    name="description"
                    className="form-input-description"
                    value={formData.description}
                    onChange={handleChange}
                  />
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="div-flex-start setting-sidebar-container div-flex-end">
        <button className="btn-black" type="submit" onClick={handleSubmit}>
          Submit
        </button>
      </div>
    </div>
  );
}
